import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Spinner from '../../components/common/Spinner';

const FALLBACK = `제1조 (목적)
(주)조군산업(이하 "회사")은 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다.

제2조 (수집하는 개인정보 항목)
회사는 서비스 제공을 위해 다음의 개인정보를 수집합니다.
• 필수항목: 이름, 연락처(휴대폰번호), 업체명, 대표자명, 아이디, 비밀번호
• 선택항목: 지역, 사업자등록번호, 이메일
• 자동수집: 서비스 이용기록, 접속 로그, 기기정보

제3조 (개인정보의 수집 및 이용 목적)
• 회원 가입 및 관리: 본인확인, 가입의사 확인, 서비스 부정이용 방지
• 서비스 제공: 일정 관리, 자재 주문, 업체 간 정보 공유
• 고충처리: 민원인 확인, 사실조사, 처리결과 통보

제4조 (개인정보의 보유 및 이용 기간)
회원 탈퇴 시까지 보유하며, 관련 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관합니다.
• 계약 또는 청약철회 등에 관한 기록: 5년
• 대금결제 및 재화 등의 공급에 관한 기록: 5년
• 소비자 불만 또는 분쟁처리에 관한 기록: 3년

제5조 (개인정보의 제3자 제공)
회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 이용자가 사전에 동의한 경우 또는 법령의 규정에 의한 경우는 예외로 합니다.

제6조 (개인정보의 파기)
회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.

제7조 (이용자의 권리)
이용자는 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며, 가입 해지(회원 탈퇴)를 요청할 수 있습니다.

제8조 (개인정보 보호 책임자)
성명: (주)조군산업 개인정보보호팀
연락처: 1544-5023

부칙
본 개인정보 처리방침은 2026년 2월 24일부터 시행합니다.`;

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'policies', 'privacy'));
        setContent(snap.exists() ? snap.data().content : FALLBACK);
      } catch {
        setContent(FALLBACK);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={22} /></BackBtn>
        <Title>개인정보 처리방침</Title>
        <Spacer />
      </Header>
      <Content>
        {loading ? <Spinner variant="dots" size="md" fullPage /> : <PolicyText>{content}</PolicyText>}
      </Content>
    </Container>
  );
};

export default PrivacyPolicyPage;

const Container = styled.div`min-height: 100vh; background: #F4F3F8;`;
const Header = styled.div`display: flex; align-items: center; justify-content: space-between; padding: 16px 16px 14px; background: white; border-bottom: 1px solid #EEEEF0;`;
const BackBtn = styled.button`display: flex; padding: 4px; color: #2C3640;`;
const Title = styled.p`font-size: 16px; font-weight: 700; color: #1E2A32;`;
const Spacer = styled.div`width: 30px;`;
const Content = styled.div`padding: 20px 20px 60px;`;
const PolicyText = styled.div`font-size: 14px; color: #5A6B75; line-height: 1.8; white-space: pre-line;`;
